import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './skeleton.html',
  styleUrl: './skeleton.scss',
  encapsulation: ViewEncapsulation.None
})
export class Skeleton {
  @Input() width: string = '100%';
  @Input() height: string = '20px';
  @Input() shape: 'line' | 'circle' | 'rectangle' = 'line';
  @Input() className: string = '';

  get skeletonStyles() {
    return {
      width: this.width,
      height: this.height
    };
  }

  get skeletonClasses(): string {
    return `skeleton-item skeleton-${this.shape} ${this.className}`;
  }
}
